export class PipeRingVariantConfigModel {
    _id: string;
    isStandard: boolean;
    isCeiling: boolean;
    isWall: boolean;
    isFloor: boolean;
    isDouble: boolean;
    clampingRangeMax: number;
    clampingRangeMin: number;
    centerToBoss: number;
    width: number;
    screwSpacing: number;
    depth: number;
    spacingBetween: number;
    spacingAbove: number;
    adjustmentLength: number;
    bossReference: number;
    insulationThickness: number;
    externalDiameter: number;
    threadedRods: any[];

    constructor(_id = '',
        isStandard = null,
        isCeiling = null,
        isWall = null,
        isFloor = null,
        isDouble = null,
        clampingRangeMax = null,
        clampingRangeMin = null,
        centerToBoss = null,
        width = null,
        screwSpacing = null,
        depth = null,
        spacingBetween = null,
        spacingAbove = null,
        adjustmentLength = null,
        bossReference = null,
        insulationThickness = null,
        externalDiameter = null,
        threadedRods = []
    ) {
        this._id = _id;
        this.isStandard = isStandard;
        this.isCeiling = isCeiling;
        this.isWall = isWall;
        this.isFloor = isFloor;
        this.isDouble = isDouble;
        this.clampingRangeMax = clampingRangeMax;
        this.clampingRangeMin = clampingRangeMin;
        this.centerToBoss = centerToBoss;
        this.width = width;
        this.screwSpacing = screwSpacing;
        this.depth = depth;
        this.spacingBetween = spacingBetween;
        this.spacingAbove = spacingAbove;
        this.adjustmentLength = adjustmentLength;
        this.bossReference = bossReference;
        this.insulationThickness = insulationThickness;
        this.externalDiameter = externalDiameter;
        this.threadedRods = threadedRods;
    }
}
